<script setup lang="ts">
import { Input } from '@proj-airi/ui'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  providerName: string
  placeholder?: string
  required?: boolean
  label?: string
  description?: string
}>()

const { t } = useI18n()

const rawValue = defineModel<string>({ required: true })

// 自动剥离空白/换行，避免输入法粘贴带入不可见字符导致验证失败
const modelValue = computed({
  get: () => rawValue.value ?? '',
  set: (v: string) => {
    rawValue.value = (v ?? '').replace(/\s+/g, '')
  },
})

const computedDescription = computed(() => {
  return props.description || `API Key for ${props.providerName}`
})

const revealed = ref(false)
</script>

<template>
  <div max-w-full>
    <label flex="~ col gap-4">
      <div>
        <div class="flex items-center gap-1 text-sm">
          {{ label || t('settings.pages.providers.common.fields.field.api-key.label') }}
          <span v-if="required !== false" class="text-red-500">*</span>
        </div>
        <div class="break-words text-xs text-neutral-500 leading-relaxed dark:text-neutral-400">
          {{ computedDescription }}
        </div>
      </div>

      <div class="relative w-full">
        <Input
          v-model="modelValue"
          :type="revealed ? 'text' : 'password'"
          :placeholder="placeholder"
          class="!pr-10"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          name="provider-api-key"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other"
        />
        <button
          type="button"
          class="absolute inset-y-0 right-1 my-auto h-7 w-7 flex items-center justify-center rounded text-neutral-500 transition-colors hover:bg-neutral-100 dark:text-neutral-400 hover:text-neutral-700 dark:hover:bg-neutral-800 dark:hover:text-neutral-200"
          :aria-label="revealed ? t('settings.pages.providers.common.fields.field.api-key.hide') : t('settings.pages.providers.common.fields.field.api-key.show')"
          :title="revealed ? t('settings.pages.providers.common.fields.field.api-key.hide') : t('settings.pages.providers.common.fields.field.api-key.show')"
          @click.prevent.stop="revealed = !revealed"
        >
          <div :class="revealed ? 'i-solar:eye-closed-bold-duotone' : 'i-solar:eye-bold-duotone'" text-base />
        </button>
      </div>
    </label>
  </div>
</template>
